import React, { HTMLAttributes } from 'react';
import classes from './data-item.module.css';
import ActionsMenu from './actions-menu';

interface IDataItem {
	renderCard?: Element;
	actions: any;
}

const DataItem: React.FC<HTMLAttributes<HTMLDivElement> & IDataItem> = ({ children, renderCard, actions }) => {
	return (
		<div className={classes.DataItem}>
			<>
				{children || renderCard}
				<ActionsMenu options={actions} dotsOrientation="vertical" />
			</>
		</div>
	);
};

export default DataItem;
